import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-pause",
  templateUrl: "./med-icon-pause.component.html",
})
export class MedIconPauseComponent extends SvgMixinComponent {}
